/* eslint-disable max-len */
// Copyright (c) 2016 Deere & Company

import { resetAccountLookup, updateAccountLookup } from './account-lookup';
import { resetProductDetails, updateProduct } from './product';
import { createTransfer } from './create-new-transfer';
import { goToPreviousView } from '../../shared/action-creators/go-to-previous-view';
import { goToStatusChangeRequestView } from '../../shared/action-creators/status-change-request-view';
import { readDealer } from './read-dealer';
import { resetNewTransfer } from './reset-new-transfer';
import { updateAmountOfUseModalVisibility } from './amount-of-use-modal-visibility';
import { updateDealerSearchModalVisibility } from './dealer-search-modal';
import { updateNewTransfer } from './update-new-transfer';
import { updateNewTransferNewDealer } from './update-new-dealer';
import { updateNewTransferStatusChangeModal } from './new-transfer-status-change-modal';
import { updateReasonForChange } from './update-reason-for-change';

export default {
    createTransfer,
    goToPreviousView,
    goToStatusChangeRequestView,
    readDealer,
    resetAccountLookup,
    resetNewTransfer,
    resetProductDetails,
    updateAccountLookup,
    updateAmountOfUseModalVisibility,
    updateDealerSearchModalVisibility,
    updateNewTransfer,
    updateNewTransferNewDealer,
    updateNewTransferStatusChangeModal,
    updateProduct,
    updateReasonForChange,
};
